package io.daio.pancake.icons

object Icons
